/**
 * ScrollToTop — resets scroll position on every route change.
 * Uses Lenis scrollTo when available (smooth scroll context),
 * falls back to native window.scrollTo for touch/native/reduced-motion.
 */

import { useEffect } from "react";
import { useLocation } from "react-router";
import { useLenis } from "@/components/providers/lenisHooks";

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, lenis]);

  return null;
};
